export default "__VITE_ASSET__D0Dgldw1__"